import React, { useState, useEffect } from "react"
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete"
import { connect } from "react-redux"
import { change } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Col, Row } from "reactstrap"

const LocationAutocomplete = ({
  input = {},
  label,
  meta: { touched, error },
  change,
}) => {
  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null,
  })

  const handleSelect = async value => {
    const results = await geocodeByAddress(value)
    const latLng = await getLatLng(results[0])
    setCoordinates(latLng)
    change("details.locationDetails.lat", latLng.lat)
    change("details.locationDetails.lng", latLng.lng)
    input.onChange(value)
  }

  const handleChange = address => {
    input.onChange(address)
    setCoordinates(null)
  }

  return (
    <PlacesAutocomplete
      value={input.value}
      onSelect={handleSelect}
      onChange={handleChange}
      onError={(status, clearSuggestions) => {
        console.log("Google Maps API returned error with status: ", status)
        clearSuggestions()
      }}
      highlightFirstSuggestion={true}
      shouldFetchSuggestions={input.value.length > 2}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <Row>
            <Col sm={11}>
              <input
                {...getInputProps({
                  className: "location-search-input",
                })}
                style={{
                  background: "transparent",
                  borderWidth: "0px 0px 1px",
                  outline: "none",
                  width: "100%",
                }}
              />
              <div className="autocomplete-dropdown-container">
                {loading && <div>Loading...</div>}
                {suggestions.map((suggestion, index) => {
                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item"
                  const style = suggestion.active
                    ? { backgroundColor: "#fafafa", cursor: "pointer" }
                    : { backgroundColor: "#ffffff", cursor: "pointer" }
                  return (
                    <div
                      key={index}
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            </Col>
            {input.value.length > 0 && (
              <Col sm={1}>
                <i
                  className="bx bx-sm bx-x"
                  style={{
                    paddingLeft: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    input.onChange("")
                    change("details.locationDetails.lat", "")
                    change("details.locationDetails.lng", "")
                  }}
                />
              </Col>
            )}
          </Row>
          <Row>
            {touched && error && <span className={"input-error"}>{error}</span>}
          </Row>
        </div>
      )}
    </PlacesAutocomplete>
  )
}

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.SUB_CALENDARS, `${field}`, value)),
})

export default connect(null, mapDispatchToProps)(LocationAutocomplete)
